module.exports = __webpack_public_path__ + "app/modals/wz-delete-modal.view.html";